import {Action, Card} from 'platform/components';
import {Align, Box, Text, VStack} from 'platform/foundation';

import {useState} from 'react';

import {
  GetReceiveNoteFastTrackResponse,
  PatchReceiveNoteItem,
  usePatchReceiveNoteFastTrackMutation,
} from '@dms/api/warehouse';
import i18n from '@dms/i18n';
import {handleApiError} from '@dms/shared';

import {FastTrackIssuesCard} from './FastTrackIssuesCard';

export interface FastTrackIssuesTabProps {
  receiveNoteId: string;
  receiveNoteFastTracks?: GetReceiveNoteFastTrackResponse;
  isReceiveNoteCompleted: boolean;
}

export function FastTrackIssuesTab(props: FastTrackIssuesTabProps) {
  const [collapsedAll, setCollapsedAll] = useState(false);

  const [patchReceiveNoteFastTrack, {isLoading}] = usePatchReceiveNoteFastTrackMutation();

  const handleCollapseAll = () => {
    setCollapsedAll(!collapsedAll);
  };

  const handleAcceptAll = () => {
    if (!props.receiveNoteFastTracks) {
      return;
    }

    const updatedReceiveNoteItems = props.receiveNoteFastTracks.receiveNoteItems.map(
      (receiveNoteItem) => ({
        receiveNoteItemId: receiveNoteItem.receiveNoteItemId,
        isAccepted: true,
        fastTrackItem: receiveNoteItem.fastTruckIssues.map((fastTruckIssue) => ({
          fastTrackItemId: fastTruckIssue.fastTruckItemId,
          isSelected: fastTruckIssue.isSelected,
        })),
      })
    );

    patchReceiveNoteFastTrack({
      receiveNoteId: props.receiveNoteId,
      body: {
        receiveNoteItem: updatedReceiveNoteItems,
      },
    })
      .unwrap()
      .catch(handleApiError);
  };

  const handleOnAcceptIssue = (updatedReceiveNoteItem: PatchReceiveNoteItem) => {
    patchReceiveNoteFastTrack({
      receiveNoteId: props.receiveNoteId,
      body: {
        receiveNoteItem: [updatedReceiveNoteItem],
      },
    })
      .unwrap()
      .catch(handleApiError);
  };

  const isItems = props.receiveNoteFastTracks?.receiveNoteItems?.length;

  const actions: Action[] = [
    {
      type: 'button',
      title: collapsedAll
        ? i18n.t('entity.warehouse.labels.expandAll')
        : i18n.t('entity.warehouse.labels.collapseAll'),
      leftIcon: collapsedAll ? 'action/expand_all' : 'action/collapse_all',
      variant: 'link',
      onClick: () => handleCollapseAll(),
      isDisabled: props.isReceiveNoteCompleted,
    },
    {
      type: 'button',
      title: i18n.t('entity.warehouse.labels.acceptAll'),
      variant: 'primary',
      onClick: () => handleAcceptAll(),
      isDisabled: props.isReceiveNoteCompleted,
    },
  ];

  return (
    <Card title={i18n.t('entity.warehouse.labels.fastTrackIssues')} actions={actions}>
      {isItems ? (
        <VStack spacing={4}>
          {props.receiveNoteFastTracks?.receiveNoteItems.map((receiveNoteItem, index) => (
            <FastTrackIssuesCard
              key={index}
              isCollapsedAll={collapsedAll}
              receiveNoteItem={receiveNoteItem}
              onAcceptIssue={handleOnAcceptIssue}
              isPending={isLoading}
              isReceiveNoteCompleted={props.isReceiveNoteCompleted}
            />
          ))}
        </VStack>
      ) : (
        <Box padding={4}>
          <Align center>
            <Text>{i18n.t('entity.warehouse.labels.noFastTrackIssues')}</Text>
          </Align>
        </Box>
      )}
    </Card>
  );
}
